// src/component/Forget/forgetPassword.jsx

import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  IconButton,
  OutlinedInput,
  InputAdornment,
  FormControl,
  Box,
  Snackbar,
  Alert,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Image from "../../asserts/signup.png";
import { NavLink, useNavigate } from "react-router-dom";

import { axiosInstance } from "../Api/instance";
import { PrimaryButton } from "../ui/Buttons";
import { styled } from "@mui/material/styles";

const PageContainer = styled(Grid)(({ theme }) => ({
  minHeight: "100vh",
  backgroundColor: theme.palette.background.default,
  overflow: "hidden",
}));

const FormContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "48px 40px",
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.down("sm")]: {
    padding: "32px 20px",
  },
}));

const ImageContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1F2937' : '#F8FAFC',
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const PasswordInput = ({
  label,
  id,
  showPassword,
  handleClickShowPassword,
  handleMouseDownPassword,
  value,
  onChange,
}) => (
  <Box style={{ marginBottom: "20px" }}>
    <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: "8px", display: "flex", alignItems: "center", gap: "6px" }}>
      {label}
      <LockIcon fontSize="inherit" color="action" />
    </Typography>
    <FormControl fullWidth variant="outlined">
      <OutlinedInput
        id={id}
        type={showPassword ? "text" : "password"}
        placeholder="••••••••"
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={`toggle ${label.toLowerCase()} password visibility`}
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        value={value}
        onChange={onChange}
      />
    </FormControl>
  </Box>
);

const Forget = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [conpass, setconpass] = useState("");
  const [password, setpassword] = useState("");
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const email = localStorage.getItem("forget");
  console.log(email);
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Snackbar Toast notification
  const [toast, setToast] = useState({ open: false, message: "", severity: "info" });

  const showToast = (message, severity = "info") => {
    setToast({ open: true, message, severity });
  };

  const handlePassword = async () => {
    if (!password || !conpass) {
      showToast("Please fill in all fields", "warning");
      return;
    }

    if (password === conpass) {
      setLoading(true);
      try {
        const response = await axiosInstance.post(`put/U_updatePassword.php`, {
          email: email,
          password: password,
        });
        if (response.status === 200) {
          if (response.data.message === "timeout") {
            Navigate("/signin");
            return;
          }
          showToast("Your password changed successfully", "success");
          setTimeout(() => Navigate("/signin"), 1500);
        }
      } catch (error) {
        console.error("Error check email or password:", error);
        showToast("Error updating password. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    } else {
      showToast("Password and Confirm Password are mismatched", "error");
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleMouseDownPassword1 = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <PageContainer container>
      <Snackbar 
        open={toast.open} 
        autoHideDuration={4000} 
        onClose={() => setToast(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert 
          onClose={() => setToast(prev => ({ ...prev, open: false }))} 
          severity={toast.severity} 
          sx={{ width: "100%", borderRadius: "12px", boxShadow: 3 }}
        >
          {toast.message}
        </Alert>
      </Snackbar>

      {/* Form Left Panel */}
      <FormContainer item xs={12} sm={6}>
        <Box style={{ maxWidth: "420px", width: "100%", margin: "0 auto" }}>
          <Typography variant="h2" style={{ fontWeight: 800, color: "var(--color-primary)", marginBottom: "8px" }}>
            Reset Password
          </Typography>
          <Typography variant="body1" color="textSecondary" style={{ marginBottom: "32px" }}>
            Enter your new password to regain access to your student profile.
          </Typography>

          <form onSubmit={(e) => { e.preventDefault(); handlePassword(); }}>
            <PasswordInput
              label="New Password"
              id="new-password"
              showPassword={showPassword}
              handleClickShowPassword={handleClickShowPassword}
              handleMouseDownPassword={handleMouseDownPassword}
              value={password}
              onChange={(event) => setpassword(event.target.value)}
            />
            
            <PasswordInput
              label="Confirm New Password"
              id="confirm-password"
              showPassword={showPassword1}
              handleClickShowPassword={handleClickShowPassword1}
              handleMouseDownPassword={handleMouseDownPassword1}
              value={conpass}
              onChange={(event) => setconpass(event.target.value)}
            />

            <PrimaryButton
              type="submit"
              loading={loading}
              style={{ width: "100%", height: "46px", marginTop: "12px" }}
            >
              Update Password
            </PrimaryButton>

            <Box style={{ textAlign: "center", marginTop: "24px" }}>
              <NavLink to="/signin" style={{ textDecoration: "none", color: "var(--color-primary)", fontWeight: 700, fontSize: "0.875rem" }}>
                Back to Sign In
              </NavLink>
            </Box>
          </form>
        </Box>
      </FormContainer>

      {/* Decorative Right Panel */}
      <ImageContainer item xs={12} sm={6}>
        <img
          src={Image}
          alt="Reset Password"
          style={{
            width: "90%",
            maxHeight: "80vh",
            objectFit: "contain",
            borderRadius: "20px",
          }}
        />
      </ImageContainer>
    </PageContainer>
  );
};

export default Forget;
